import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { parseSheetName, createXlsxSingleTb } from "../../../service/excel";

function useExcel() {
  const exportExcel = async ({
    fileName = "",
    headColumns = [],
    data = [],
    createAction = () => null,
  }) => {
    const workbook = new ExcelJS.Workbook(),
      workbookName = parseSheetName(fileName);

    createXlsxSingleTb({
      isNewSheet: true,
      isTitle: false,
      titleOptions: {
        label: workbookName,
        position: { x: 0, y: 0 },
      },
      totalOptions: {
        isSum: false,
      },
      workbook,
      tbHeadColumns: headColumns,
      tbData: data,
    });

    const mainBuffer = await workbook.xlsx.writeBuffer();
    const mainFileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const mainBlob = new Blob([mainBuffer], { type: mainFileType });
    saveAs(mainBlob, `${workbookName}.xlsx`);
  };

  return { exportExcel };
}

export default useExcel;
